import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contact: "/contact",
};

const endpointsSlice = createSlice({
  name: "endpoints",
  initialState,
  reducers: {},
});

export default endpointsSlice.reducer;
